var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.817,
    height: 14.842,
    viewBox: "0 0 14.817 14.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinterest",
    transform: "translate(-0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_606",
    "data-name": "Trac\\xE9 606",
    d: "M7.435,0a7.417,7.417,0,0,0-2.7,14.323,7.146,7.146,0,0,1,.024-2.13c.134-.58.866-3.686.866-3.686a2.7,2.7,0,0,1-.22-1.1c0-1.032.6-1.8,1.343-1.8a.932.932,0,0,1,.94,1.044,14.634,14.634,0,0,1-.617,2.472,1.079,1.079,0,0,0,1.1,1.343c1.318,0,2.331-1.391,2.331-3.393A2.926,2.926,0,0,0,7.4,4.059,3.209,3.209,0,0,0,4.047,7.275,2.9,2.9,0,0,0,4.6,8.966a.217.217,0,0,1,.049.213c-.055.232-.183.738-.208.842-.03.134-.11.164-.25.1A3.323,3.323,0,0,1,2.68,7.244c0-2.338,1.7-4.485,4.9-4.485a4.352,4.352,0,0,1,4.571,4.284c0,2.557-1.611,4.614-3.845,4.614a1.969,1.969,0,0,1-1.7-.855l-.464,1.764a8.074,8.074,0,0,1-.921,1.947,7.427,7.427,0,0,0,9.613-7.086A7.4,7.4,0,0,0,7.435,0Z",
    fill: "#165227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.8a77b8a8b81ff85e1e6abb12c49e8af8.svg";
export { ForwardRef as ReactComponent };